export default __webpack_public_path__ + "static/media/birthday-candle.09fd6172.webp";